import { render, staticRenderFns } from "./ResumeWrapper.vue?vue&type=template&id=2137ef19&"
import script from "./ResumeWrapper.vue?vue&type=script&lang=js&"
export * from "./ResumeWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports